import React, { FC } from 'react';
import Tooltip from '../Tooltip/Tooltip';
import InformationIcon from '../Icons/InformationIcon';
import Typo from '../Typography/Typo';
import { useAnalytics } from '../AnalyticsProvider/AnalyticsProvider';

type TArticleToolbarTimepointsProps = {
  totalTimePointsAccumulated: string;
};

const ArticleToolbarTimepoints: FC<TArticleToolbarTimepointsProps> = ({ totalTimePointsAccumulated }) => {
  const { sendEvent } = useAnalytics();

  const onTimepointsInfoMouseEnter = () => sendEvent('post_timepoints_info_hover');

  return (
    <Tooltip
      trigger={
        <div onMouseEnter={onTimepointsInfoMouseEnter} className="flex gap-x-[14px] items-center">
          <InformationIcon color="#131313" height="20" width="20" />
          <Typo
            variant="p2"
            text={`${Math.floor(+totalTimePointsAccumulated)} t.p.`}
            className="md:!text-p4 text-black-700 whitespace-nowrap"
          />
        </div>
      }
      direction="bottom"
    >
      <Typo variant="small-p">
        Time Points (t.p.) reflect the aggregated activity from people reading and writing this post.
      </Typo>
    </Tooltip>
  );
};

export default ArticleToolbarTimepoints;
